export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Final2_00.6f09ce62.jpg";